import React, { useState } from "react";
import {Helmet} from "react-helmet";
import "../../assets/css/idp-ug.css";
import IdpFormUg from "../../components/idp-ug-pg/idpFormUg";

const IdpUgPage = () => {
  const [domain, setDomain] = useState('')
  const getDomain = (data)=>{
    setDomain(data)
  }

  return (<>
    <Helmet>
        <title>IDP {domain}</title>
    </Helmet>
    <div className="idp_ug_pg_common idp_ug">
      <IdpFormUg getDomain={getDomain} />
    </div>
    
    </>);
};
export default IdpUgPage;
